import { CheckName } from 'dashboard/models/check/check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

export type ExpirationCheckName = CheckName.IdExpiredDetection;

export interface ExpirationThresholdConfig {
  'id-class': string;
  'country-code': string;
  subdivision: string;
  'expiration-threshold-days': number;
}

export interface ExpirationCheckConfig extends VerificationCheckConfig {
  check: ExpirationCheckName;
  'expiration-thresholds': ExpirationThresholdConfig[];
}

export function isExpirationCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is ExpirationCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.IdExpiredDetection:
      return true;
    default:
      return false;
  }
}
